export default "__VITE_ASSET__22e041dc__"